import { Worker, array_remove } from "../util";
import angular from "angular";
import moment from "moment";

export default class ForecastRulesOPMListCtrl {
  static $inject = ["ForecastRulesService", "$window","$stateParams"];
  constructor(ForecastRulesService, $window, $stateParams) {
      console.log('Received params',$stateParams);
    this.ForecastRulesService = ForecastRulesService;
    this.$window = $window;
    this.list = [];
    ForecastRulesService.listOPMs($stateParams.type, $stateParams.ruleId).then(data=>{
        this.list = data;
    });
    
  }

}




// WEBPACK FOOTER //
// ./src/ForecastRules/ForecastRulesOPMListCtrl.js